import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionService } from '../../services/version.service';
import { VersionInfo } from '../../config/version';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent implements OnInit {
  currentYear = new Date().getFullYear();
  version!: VersionInfo;
  versionString!: string;
  buildDate!: string;

  constructor(private versionService: VersionService) {}

  ngOnInit(): void {
    this.version = this.versionService.getVersion();
    this.versionString = this.versionService.getVersionString();
    this.buildDate = new Date(this.version.buildDate).toLocaleDateString();
  }
}
